/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

const CONTENT = {
  coal: {
    title: 'The future of coal mining in the Hunter region',
    description:
      'Click on icons for details about expected closures of coal mines beyond 2030.',
  },
  renewable: {
    title: 'Renewable energy projects in Hunter-Central Coast',
    description:
      'Click on icons for status of projects in the Hunter-Central Coast Renewable Energy Zone.',
  },
};

export default function Header({ project = 'coal' }) {
  const content = CONTENT[project] || CONTENT.coal;

  return (
    <header>
      <div className="headline">{content.title}</div>
      <p>{content.description}</p>
    </header>
  );
}
